define('@brightspark/sparkling-observable-js', [], function(){

    var unshift = Array.prototype.unshift;
    var slice = Array.prototype.slice;

    /**
     * Filters an array based on a predicate.
     * @param {array} array - array to filter
     * @param {function} fn - a function to test each element for a condition
     */
    function filterArray(array, fn) {
        var results = [];
        var item;
        for (var i = 0, len = array.length; i < len; i++) {
            item = array[i];
            if (fn(item)) {
                results.push(item);
            }
        }
        return results;
    }

    var module = function() {

        if (typeof this.publishSubscribe == "function") {
            // already observable
            return;
        }

        var _this = this;
        var _handlers = {};

        /**
         * Subscribe handler to event
         * @param {string} eventName
         * @param {function} handler
         * @returns {object} this observable (for chaining)
         */
        this.subscribe = function (eventName, handler) {
            if (typeof handler !== "function") {
                return;
            }

            if (!_handlers[eventName]) {
                _handlers[eventName] = [];
            }
            _handlers[eventName].push(handler);

            return _this;
        };

        /**
         * Unsubscribe handler from event
         * @param {string} eventName
         * @param {function} handler
         * @returns {object} this observable (for chaining)
         */
        this.unsubscribe = function (eventName, handler) {
            if (_handlers[eventName]) {
                if (handler) {
                    // replace events handlers array with new array where specified handler is excluded
                    _handlers[eventName] = filterArray(_handlers[eventName], function (item) {
                        return item !== handler;
                    });
                } else {
                    _handlers[eventName] = [];
                }
            }

            return _this;
        };

        /**
         * Publish event to subscribed handlers
		 * @param {String} eventName - name of an event to publish
		 * @param {*[]} - arguments to pass to each subscriber
		 * @returns {Boolean} if some subscriber stopped propagation
         */
        this.publish = function (eventName) {
            if (!_handlers[eventName]) {
                return true;
            }

            for (var i = 0; i < _handlers[eventName].length; i++) {
                var args = slice.call(arguments, 1);
                var res = _handlers[eventName][i].apply(this, args);
                if (res === false) {
                    return false;
                }
            }

            return true;
        };

        /**
         * Subscribes to event if a function is passed,
         * otherwise publishes event with passed arguments
         * @param {string} eventName
         * @param {array} args
         */
        this.publishSubscribe = function (eventName, args) {

            args = args || [];
            var handler = args[0];

            if (typeof handler === "function") {
                return _this.subscribe(eventName, handler);
            }

            unshift.call(args, eventName);
            return _this.publish.apply(this, args);
        };

        /**
         * Helper to create publish-subscribe function
         * @param {string} eventName
         * @returns {function} - publish-subscribe function
         */
        this.createPublishSubscribe = function (eventName) {
            return function () {
                return _this.publishSubscribe.call(this, eventName, arguments);
            };
        };

        /**
         * Helper to create subscriber function
         * @param {string} eventName
         */
        this.createSubscriber = function (eventName) {
            return function (handler) {
                return _this.subscribe(eventName, handler);
            };
        };
    };

    module.mixin = function (destination) {

        // base
        module.call(destination);

        // extensions
        var source = module.prototype;
        for (var i in source) {
            if (source.hasOwnProperty(i)) {
                destination[i] = source[i];
            }
        }
    };

    return module;

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@brightspark/sparkling-observable-js/sparkling-observable.js
// module id = 264
// module chunks = 10